import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "./utils/snackBarUtils";
import MuiTheme from "./themes/MuiTheme";
import { BrowserRouter } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <MuiTheme>
      <SnackbarProvider>
        <SnackbarUtilsConfigurator />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SnackbarProvider>
    </MuiTheme>
  </Provider>
  // </React.StrictMode>
);

reportWebVitals();
